/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Geschlechtdesbuddies2Inputs */

const en__field_geschlechtdesbuddies2 = /** @type {(inputs: _Field_Geschlechtdesbuddies2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender of the Buddy`)
};

const de__field_geschlechtdesbuddies2 = /** @type {(inputs: _Field_Geschlechtdesbuddies2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht des Buddies`)
};

/**
* | output |
* | --- |
* | "Gender of the Buddy" |
*
* @param {_Field_Geschlechtdesbuddies2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_geschlechtdesbuddies2 = /** @type {((inputs?: _Field_Geschlechtdesbuddies2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Geschlechtdesbuddies2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_geschlechtdesbuddies2(inputs)
	return de__field_geschlechtdesbuddies2(inputs)
});
export { _field_geschlechtdesbuddies2 as "_field_geschlechtDesBuddies" }